/**
 * Resolving what the user typed to a food the catalog knows.
 *
 * One definition, because two would drift: the same answer decides where a new grocery entry
 * is drafted, how long it keeps, and — since a restock is a match on food type — whether an
 * arrival replenishes something the household already has or sits beside it.
 *
 * Matching mirrors `Catalog::resolve` in `api/core/src/catalog.rs`, aliases included. It has
 * to: the *client* is what drafts an entry from a typed name, so a name only the server could
 * resolve ("cooked chicken", "mayo", "oj") would silently arrive with no shelf life and land
 * in whatever place the fallback picked.
 */

import type { Food } from '../api/types';

export function resolveFood(catalog: Food[], name: string): Food | null {
  const wanted = normalize(name);

  return (
    catalog.find(
      (food) =>
        food.slug === wanted ||
        normalize(food.name) === wanted ||
        food.aliases.some((alias) => normalize(alias) === wanted),
    ) ?? null
  );
}

/** Lowercase, trim, and collapse internal whitespace, so "  Ground  Beef " finds ground beef. */
function normalize(name: string): string {
  return name.trim().toLowerCase().split(/\s+/).join(' ');
}
